



















































// this component for simple dialog confirmation. e.g: yes/no
import {
    Component, Vue, Prop, Watch, Model,
} from 'vue-property-decorator';
import CustomDialog from '@/components/global/CustomDialog.vue';
import index from '@/store';
import { ProductTemplate } from '@/assets/interface/Product';

@Component({
    components: {
        CustomDialog,
    },
})
export default class SimpleDialog extends Vue {
    @Model('update:simpleDialogValue', { type: Boolean }) readonly value!: boolean;
    @Prop({ default: '' }) readonly header!:string;
    @Prop({ default: 'Yes' }) readonly positiveLabel!:string;
    @Prop({ default: false }) readonly positiveActionLoading!:boolean;
    @Prop({ default: 'primary' }) readonly positiveButtonColor!:string;
    @Prop({ default: 'white' }) readonly positiveLabelColor!:string;
    @Prop({ default: 'No' }) readonly negativeLabel!:string;
    @Prop({ default: true }) readonly showNegativeButton!:boolean
    @Prop({ default: '120px' }) readonly contentHeight!:string;
    @Prop({ default: true }) readonly persistent!:boolean;
    @Prop({ default: '380px' }) readonly maxWidth!:string;
    @Prop({ default: true }) readonly autoClose!:boolean;

    public enterKeyboard = (event: any) => {
        const that = this;
        if (event.keyCode === 13) {
            that.onActionClick(true);
        }
    };

    public onActionClick(res: boolean) {
        this.$emit('actionClick', res);
        if (res && !this.autoClose) return;
        this.emitReturnValue(false);
    }

    public emitReturnValue(event: any) {
        this.$emit('update:simpleDialogValue', event);
    }

    public mounted() {
        const that = this;
    }

    @Watch('value', { immediate: true })
    private onValueChange(val: boolean) {
        if (val) {
            window.addEventListener('keyup', this.enterKeyboard);
        } else {
            window.removeEventListener('keyup', this.enterKeyboard);
        }
    }
}
